module.exports = __webpack_public_path__ + "static/media/chai.76389781.png";